import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { Customer } from '../interfaces/customer';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class CustomerService {
  constructor(private apiService: ApiService) {}

  public async getCustomer(slug: string): Promise<Customer> {
    const url = `/api/v3/customers/${slug}`;
    return lastValueFrom<Customer>(
      this.apiService.identifiedGet(url, new HttpParams())
    );
  }

  public async getCustomerUniqueFollowers(customer: Customer): Promise<number> {
    const url = `/api/v2/customers/${customer.slug}/followers`;
    return lastValueFrom<number>(
      this.apiService.identifiedGet(url, new HttpParams())
    );
  }
}
